import React, { useState } from 'react';
import { useStripeContext } from '../stripe/StripeContext';
import PricingDetail from '../components/PricingDetail';
import { useUserContext } from '../contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

// REMPLACE ICI par tes vrais Price IDs annuels !
const PRICE_IDS = {
  oneTime: 'price_1RlrzHLuXqiGvqVbisv7Hrz9',
  standard: {
    monthly: 'price_1Rls32LuXqiGvqVb6dkVLVGU',
    annual: 'price_1Rls4oLuXqiGvqVbljTJM5tT', // <-- remplace par le vrai price id annuel Standard Stripe !
  },
  professional: {
    monthly: 'price_1Rls5LLuXqiGvqVbLcp6h9Bd',
    annual: 'price_1Rls5jLuXqiGvqVbrjFVw3KH', // <-- remplace par le vrai price id annuel Pro Stripe !
  }
};

function Pricing() {
  const [isAnnual, setIsAnnual] = useState(false);
  const { createCheckoutSession, loading: stripeLoading, error: stripeError } = useStripeContext();
  const { userInfo } = useUserContext();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const toggleBilling = () => setIsAnnual((prev) => !prev);
  const getDiscountedPrice = (basePrice, opts = {}) => {
    // opts.oneTime = true si c’est le plan one time
    if (opts.oneTime) {
      return `${basePrice} €`;
    }
    const price = isAnnual ? (basePrice * 0.8).toFixed(2) : basePrice.toFixed(2);
    return `${price} € / ${t('month')}`;
  };


  // Handlers avec passage du mode
  const handleCheckout = async (priceId, mode) => {
    if (!userInfo) {
      navigate('/login');
      return;
    }
    try {
      const sessionUrl = await createCheckoutSession(priceId, 1, mode);
      window.location.href = sessionUrl;
    } catch (err) {
      console.error('[Pricing] Erreur createCheckoutSession :', err);
    }
  };

  // Pour Standard/Pro, choisit priceId et mode selon toggle
  const getStandardPriceId = () => isAnnual ? PRICE_IDS.standard.annual : PRICE_IDS.standard.monthly;
  const getProfessionalPriceId = () => isAnnual ? PRICE_IDS.professional.annual : PRICE_IDS.professional.monthly;

  return (
    <>
      <Helmet>
        <title>BeOnWall – Tarifs & abonnements</title>
        <meta name="description" content="Découvrez nos offres : plan gratuit, abonnement mensuel ou annuel. Commencez sans engagement !" />
        <meta name="keywords" content="BeOnWall, QR code, photo en direct, live photo, album numérique, photowall, livre d'or numérique, photo booth app, photo stream, wedding captions, guestbook, candid photo, qr scan, create qr code, link to qr, scan qr code from image, soirée, mariage, anniversaire, événement interactif" />
        <meta property="og:title" content="BeOnWall – Tarifs & abonnements" />
        <meta property="og:description" content="Choisissez l'offre qui vous convient pour profiter pleinement de BeOnWall." />
        <meta property="og:url" content="https://www.beonwall.com/pricing" />
        <meta property="og:image" content="https://www.beonwall.com/assets/logobeonwall.png" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <PricingDetail
        isAnnual={isAnnual}
        toggleBilling={toggleBilling}
        getDiscountedPrice={getDiscountedPrice}
        stripeLoading={stripeLoading}
        stripeError={stripeError}
        handleOneTimeClick={() => handleCheckout(PRICE_IDS.oneTime, 'payment')}
        handleStandardClick={() => handleCheckout(getStandardPriceId(), 'subscription')}
        handleProfessionalClick={() => handleCheckout(getProfessionalPriceId(), 'subscription')}
      />
      <Footer />
    </>
  );      
  
}

export default Pricing;
